var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-title',{staticClass:"text-center"},[_c('strong',[_vm._v("PCM Soluções")]),_vm._v(" "+_vm._s(!_vm.getClientName ? null : (" | " + _vm.getClientName))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }